/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ResendOTPChallengeResponse } from '../models/ResendOTPChallengeResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OtpService {
    /**
     * Resend OTP Challenge
     * Resend OTP for the current step (SMS, WhatsApp, or Email).
     * @param mfaSession
     * @returns ResendOTPChallengeResponse Successful Response
     * @throws ApiError
     */
    public static resendOtpChallenge(
        mfaSession?: (string | null),
    ): CancelablePromise<ResendOTPChallengeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mfa/otp/resend',
            cookies: {
                'mfa_session': mfaSession,
            },
            errors: {
                400: `Flow has no alternative method, session has no active step, or factor type unsupported for the requested action`,
                401: `MFA session expired / flow not found`,
                403: `Submit/choose rejected by orchestrator`,
                422: `Validation Error`,
            },
        });
    }
}
